// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Yat8","header":"MergedInvoice_header__3TH6Z"};